<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in" duration="150">
      <keep-alive :max="20">
        <router-view :key="viewKey" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    refreshKey() {
      return this.$store.state.tagsView.refreshKeys[this.$route.fullPath] || 0
    },
    viewKey() {
      // 切换 tab 复用缓存；refreshKey 变化时强制重建（手动刷新 / 关闭 tab 后再次进入）
      return `${this.$route.fullPath}__${this.refreshKey}`
    },
  },
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
